import { Box, Stack, Typography } from "@mui/material";

import { CarrierStatsRow } from "components/CarrierStatsRow";
import { CompanyPrivilegedReviewsContainer } from "components/CompanyPrivilegedReviews";
import { EvotruxDivider } from "components/EvotruxDivider";
import { useCarrierStats } from "hooks";

import type { CompanyProfile, CompanyReviewProfile } from "types/company";

interface Props {
  companyProfile: CompanyProfile;
  reviewsError: string | null;
  loadingReviews: boolean;
  reviewProfile: CompanyReviewProfile | null;
  refetchReviews: VoidFunction;
}

export function CompanyProfileReviews(props: Props) {
  const {
    companyProfile,
    reviewsError,
    loadingReviews,
    reviewProfile,
    refetchReviews,
  } = props;

  const { carrierMeta } = useCarrierStats({
    companyId: companyProfile.company.id,
  });

  return (
    <Stack my="2rem" divider={<EvotruxDivider />}>
      <Stack direction="row">
        <Typography variant="h4">Company Reviews</Typography>
        <Box marginLeft="auto" alignSelf="flex-end">
          {carrierMeta && (
            <CarrierStatsRow carrierMeta={carrierMeta} withDescription />
          )}
        </Box>
      </Stack>
      <CompanyPrivilegedReviewsContainer
        companyId={companyProfile.company.id}
        error={reviewsError}
        loading={loadingReviews}
        reviewProfile={reviewProfile}
        refetchReviews={refetchReviews}
      />
    </Stack>
  );
}
